export default __webpack_public_path__ + "static/media/cardTime.735e6e9c.svg";